import React, { useMemo } from 'react'

import { type ChangeTeamStatusValue } from '@/api/changeTeamStatusValue.ts'

export type SelectTeamStatusValue = 'pause' | 'return' | 'gps' | 'region'

export type TeamStatus = ChangeTeamStatusValue

interface SelectTeamStatusContextValue {
  status?: SelectTeamStatusValue
  region?: string
  teamStatus?: TeamStatus
  setStatus(status: SelectTeamStatusValue): void
  setRegion(region: string): void
}

export const SelectTeamStatusContext = React.createContext<SelectTeamStatusContextValue>({
  setStatus() {},
  setRegion() {},
})
export const SelectTeamStatusProvider: React.FC<{
  defaultValue?: SelectTeamStatusValue
  children: React.ReactNode
}> = ({ defaultValue, children }) => {
  const [status, setStatus] = React.useState<SelectTeamStatusValue | undefined>(defaultValue)
  const [region, setRegion] = React.useState<string>()
  const value = useMemo<SelectTeamStatusContextValue>(
    () => ({
      status,
      region,
      teamStatus: status && (status !== 'region' ? { type: status } : region ? { type: status, region } : undefined),
      setStatus,
      setRegion,
    }),
    [status, region]
  )
  return <SelectTeamStatusContext.Provider value={value}>{children}</SelectTeamStatusContext.Provider>
}
